import { render, staticRenderFns } from "./ProductDatabase.vue?vue&type=template&id=a2acffd6&scoped=true&"
import script from "./ProductDatabase.vue?vue&type=script&lang=js&"
export * from "./ProductDatabase.vue?vue&type=script&lang=js&"
import style0 from "./ProductDatabase.vue?vue&type=style&index=0&id=a2acffd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2acffd6",
  null
  
)

export default component.exports